<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <g>
            <path d="M14.2,6.2H5.9c-1.9,0-3.5,1.6-3.5,3.5v30.5c0,1.9,1.6,3.5,3.5,3.5h8.4c1.9,0,3.5-1.6,3.5-3.5V9.7c0-1.9-1.6-3.5-3.5-3.5ZM5.9,9.2h8.4c.3,0,.5.2.5.5v8H5.4v-8c0-.3.2-.5.5-.5ZM14.8,20.7v8.5H5.4v-8.5h9.4ZM14.2,40.8H5.9c-.3,0-.5-.2-.5-.5v-8h9.4v8c0,.3-.2.5-.5.5Z"/>
            <path d="M44.1,6.2h-8.4c-1.9,0-3.5,1.6-3.5,3.5v30.5c0,1.9,1.6,3.5,3.5,3.5h8.4c1.9,0,3.5-1.6,3.5-3.5V9.7c0-1.9-1.6-3.5-3.5-3.5ZM35.8,9.2h8.4c.3,0,.5.2.5.5v8h-9.4v-8c0-.3.2-.5.5-.5ZM44.6,20.7v8.5h-9.4v-8.5h9.4ZM44.1,40.8h-8.4c-.3,0-.5-.2-.5-.5v-8h9.4v8c0,.3-.2.5-.5.5Z"/>
        </g>
        <path d="M27.1,25l2.1-2.1c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0l-2.1,2.1-2.1-2.1c-.6-.6-1.5-.6-2.1,0s-.6,1.5,0,2.1l2.1,2.1-2.1,2.1c-.6.6-.6,1.5,0,2.1s.7.4,1.1.4.8-.1,1.1-.4l2.1-2.1,2.1,2.1c.3.3.7.4,1.1.4s.8-.1,1.1-.4c.6-.6.6-1.5,0-2.1l-2.1-2.1Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>